import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { Accessory } from "Types/api/Accessory";
import { PaymentTypeOptions } from "Types/state";

export const getAccessoriesRequest = actionCreator(
    "accessories/get/request",
    (uuid: string, vin: string, paymentType: PaymentTypeOptions, afterFetch?: () => void) => ({
        uuid,
        vin,
        paymentType,
        afterFetch,
    }),
    () => ({ route: API.Accessories })
);

export const getAccessoriesSuccess = actionCreator(
    "accessories/get/success",
    (vin: string, paymentType: PaymentTypeOptions, response: { accessories: Accessory[] }) => ({
        vin,
        paymentType,
        accessories: response.accessories,
    })
);

export const getAccessoriesFailure = actionCreator("accessories/get/failure", (vin: string) => ({ vin }));

/**
 * POST request/success/failure
 */
export const postAccessoryRequest = actionCreator(
    "accessory/post/request",
    (uuid: string, vin: string, accessoryId: Accessory["id"]) => ({ uuid, vin, accessoryId }),
    () => ({ route: API.Accessories })
);

export const postAccessorySuccess = actionCreator(
    "accessory/post/success",
    (vin: string, accessoryId: Accessory["id"]) => ({
        vin,
        accessoryId,
    })
);

export const postAccessoryFailure = actionCreator(
    "accessory/post/failure",
    (vin: string, accessoryId: Accessory["id"]) => ({ vin, accessoryId })
);

/**
 * DELETE request/success/failure
 */
export const deleteAccessoryRequest = actionCreator(
    "accessory/delete/request",
    (uuid: string, vin: string, accessoryId: Accessory["id"]) => ({ uuid, vin, accessoryId }),
    () => ({ route: API.Accessories })
);

export const deleteAccessorySuccess = actionCreator(
    "accessory/delete/success",
    (vin: string, accessoryId: Accessory["id"]) => ({
        vin,
        accessoryId,
    })
);

export const deleteAccessoryFailure = actionCreator(
    "accessory/delete/failure",
    (vin: string, accessoryId: Accessory["id"]) => ({ vin, accessoryId })
);
